// extracted by mini-css-extract-plugin
export default {"Content":"LawListFullView_Content__sGaMM"};